import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import backBtnMobile from "../../assets/images/backBtnMobile.svg";
import backBtn from "../../assets/images/backBtn.svg";
import EducationalContentHeader from "./EducationalContentHeader";
import {
    EducationalContentContinueButton,
    EducationalContentSecondaryButton,
} from "./EducationalContentContinueButton";

const EnrollmentDeclineConfirmation = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const location = useLocation();
    const enrollmentDecision = location.state?.enrollmentDecision;
    const handleBack = () => {
        navigate("/guest-user/enrollment");
    };

    const handleDeclineBenefits = () => {
        navigate("/guest-user/giving-up-confirm-option", { state: { enrollmentDecision: "NO" } });
    };
    useEffect(() => {
        if (enrollmentDecision !== "NO") {
            navigate("/guest-user/enrollment", { replace: true });
        }
    }, [enrollmentDecision, navigate]);

    return (
        <EducationalContentHeader
            backBtnSrc={backBtn}
            backBtnMobileSrc={backBtnMobile}
            onBack={handleBack}
            title={t("Enrollment Action")}
            hideNavigation
        >
            <div className="stepperview mb-60">
                <div className="mb-24 belowline">
                    <h2 className="tgb fs-20 mb-12">{t("Are you sure you want to leave?")}</h2>
                    <p className="fs-16 lh-24">
                        {t("You’re about to remove benefits that support your care when you need it most.")}
                    </p>
                </div>

                <div className="paycheck-block">
                    <h3 className="tgb fs-20 mb-16">{t("What you’ll lose")}</h3>
                    <ul className="benefits-list fs-16 lh-24">
                        <li>{t("Easy help with booking and managing appointments")}</li>
                        <li>{t("Access to doctors for in-person and urgent care")}</li>
                        <li>{t("24/7 virtual care, anytime you need support")}</li>
                    </ul>
                </div>
            </div>

            <EducationalContentContinueButton
                hideNavigation={false}
                onContinue={handleBack}
                buttonLabel={t("No, Keep My Benefits")}
            />
            <EducationalContentSecondaryButton
                hideNavigation={false}
                onContinue={handleDeclineBenefits}
                buttonLabel={t("Yes, I want to give this up")}
            />
        </EducationalContentHeader>
    );
};

export default EnrollmentDeclineConfirmation;
